import React from "react";
import { Tooltip } from "@mui/material";
import KeyboardArrowLeft from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRight";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Diamond } from "lucide-react";
import { useTableComparison } from "../../NewProductCategories/ProductDetailsLCA/components/lcaComparison";

/**
 * Lovable-style impact category column header (chevrons + centered label + optional info).
 * Auto-wires compare diamond from TableComparisonContext when available.
 */
const ImpactCategoryHeader = ({
  categoryName,
  categoryUnit,
  onPrevious,
  onNext,
  infoTitle,
  infoMessage,
  showCompare,
  compareDisabled,
  onCompareClick,
  CompareIcon = Diamond,
}) => {
  const comparison = useTableComparison();
  const compareEnabled =
    showCompare ?? Boolean(comparison?.enabled);
  const isCompareDisabled =
    compareDisabled ?? (comparison?.selectedIds?.length ?? 0) === 0;
  const handleCompareClick =
    onCompareClick ?? (() => comparison?.openDialog?.());

  return (
    <div className="lovable-impact-header">
      <button
        type="button"
        className="lovable-impact-header__nav"
        onClick={(e) => {
          e.stopPropagation();
          onPrevious?.();
        }}
        aria-label="Previous impact category"
      >
        <KeyboardArrowLeft className="lovable-impact-header__icon" />
      </button>
      <div className="lovable-impact-header__label">
        <div className="lovable-impact-header__title">
          {infoTitle || infoMessage ? (
            <Tooltip title={infoMessage || infoTitle}>
              <span className="lovable-impact-header__title-row">
                <span className="lovable-impact-header__name">{categoryName}</span>
                <InfoOutlinedIcon className="lovable-impact-header__info-icon" />
              </span>
            </Tooltip>
          ) : (
            <span className="lovable-impact-header__name">{categoryName}</span>
          )}
        </div>
        {categoryUnit ? (
          <span className="lovable-impact-header__unit">{categoryUnit}</span>
        ) : null}
      </div>
      <button
        type="button"
        className="lovable-impact-header__nav"
        onClick={(e) => {
          e.stopPropagation();
          onNext?.();
        }}
        aria-label="Next impact category"
      >
        <KeyboardArrowRight className="lovable-impact-header__icon" />
      </button>
      {compareEnabled ? (
        <button
          type="button"
          className="lovable-impact-header__compare"
          disabled={isCompareDisabled}
          onClick={(e) => {
            e.stopPropagation();
            handleCompareClick();
          }}
          title="Compare selected rows"
        >
          <CompareIcon
            className="lovable-impact-header__compare-icon"
            strokeWidth={2.5}
          />
        </button>
      ) : (
        <span className="lovable-impact-header__compare-spacer" aria-hidden />
      )}
    </div>
  );
};

export default ImpactCategoryHeader;
